import { LDContext } from '@launchdarkly/node-server-sdk';
import React, { createContext, ReactNode } from 'react';
import { FeatureFlags, FeatureFlagsObject, LDClientClientSide } from '../types';
import { getFlags, getUser } from '../utils';

export interface FeatureFlagsProviderContext extends FeatureFlagsObject {
  client: LDClientClientSide | undefined;
}

export const FeatureFlagContext = createContext<FeatureFlagsProviderContext>({
  flags: {},
  user: {} as LDContext,
  client: {} as LDClientClientSide
});

interface FeatureFlagProviderProps {
  flags?: FeatureFlags;
  user?: LDContext;
  client?: LDClientClientSide;
  children?: ReactNode;
}

export const FeatureFlagProvider = ({
  children,
  flags,
  user,
  client
}: FeatureFlagProviderProps) => {
  const featureFlags = getFlags();
  const featureFlagsUser = getUser();

  return (
    <FeatureFlagContext.Provider
      value={{
        flags: flags ?? featureFlags,
        user: user ?? featureFlagsUser,
        client
      }}
    >
      {children}
    </FeatureFlagContext.Provider>
  );
};
